module.exports = __webpack_public_path__ + "static/img/monkey_fail.37315ce.png";


//////////////////
// WEBPACK FOOTER
// ./common/assets/img/monkey_fail.png
// module id = A0P/
// module chunks = 1